export default class ExploreBlock {
    constructor(el) {
        this.el = el;
        this.exploreButton = el.querySelector('.explore-block__explore-button');
        this.collapseButton = el.querySelector('.explore-block__collapse-button');
        this.collapsedEl = el.querySelector('.explore-block__collapsed');
        this.expandedEl = el.querySelector('.explore-block__expanded');
        this.collapsedHeight = this.collapsedEl.offsetHeight;
        this.expandedHeight = 0;
        this.expandedEl.style.display = 'none';
        this.contentHeight = 0;
        this.currentSlide = 1;
        this.currentStory = false;
        this.contentEl = this.el.querySelector('.explore-block__content-el');
        this.ctaEl = this.el.querySelector('.explore-block__cta-el');
        this.backgroundEl = this.el.querySelector('.explore-block__bg-el');
        this.stories = [];

        this.exploreButton.addEventListener('click', () => { this.expand(); });
        this.collapseButton.addEventListener('click', () => { this.collapse(); });

        this.arrowIcon = '<svg width="27" height="16" viewBox="0 0 27 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.4144 8.00003L19.0002 0.585815L17.5859 2.00003L22.5859 7L0 7V9L22.586 9L17.5859 14L19.0002 15.4142L26.4144 8.00003Z" fill="#EE3124"></path></svg>';

        this.getStories();
    }

    getStories() {
        for(const [index, el] of this.el.querySelectorAll('.explore-block__link').entries()) {
            let story = {
                el: el,
                id: index,
                active: false,
                content: JSON.parse(el.dataset.content),
                title: el.querySelector('.explore-block__link-title').innerText,
                background: el.dataset.background,
                ctaUrl: el.dataset.ctaUrl,
                ctaLabel: el.dataset.ctaLabel,
                showCta: el.dataset.showCta
            };

            if(index === 0) {
                story.active = true;
                this.currentStory = story;
            }

            story.el.addEventListener('click', (e) => {
                e.preventDefault();
                this.openStory(index);
            });

            this.stories.push(story);
        }
    }

    getStory(id) {
        return this.stories[id];
    }

    openStory(id) {
        console.log('ID', id);

        let story = this.getStory(id);
        if(!story.active) {
            this.toggleActiveState(id);
            this.currentSlide = id;
            this.currentStory = story;
            this.contentHeight = this.contentEl.offsetHeight;
            this.el.style.height = 'auto';
            let newContentHeight = 0;

            let oldBackgroundEl = this.backgroundEl.querySelector('.explore-block__bg');

            let newBackgroundEl = document.createElement("div");
            newBackgroundEl.classList.add('explore-block__bg', 'explore-block__bg--inactive');
            console.log(story);
            newBackgroundEl.style.backgroundImage = `url(${story.background})`;

            this.backgroundEl.appendChild(newBackgroundEl);
            setTimeout(() => {
                newBackgroundEl.classList.remove('explore-block__bg--inactive');
            },100);

            setTimeout(() => {
                oldBackgroundEl.remove();
            }, 2000);

            this.removeCta();

            anime({
                targets:this.contentEl,
                opacity:0,
                duration: 500,
                easing: 'easeInOutExpo',
                complete: () => {
                    this.contentEl.innerHTML = this.getStory(id).content;
                    newContentHeight = this.contentEl.offsetHeight;
                    this.contentEl.style.height = this.contentHeight + 'px';
                    console.log('new height', newContentHeight);

                    this.expandToNewContentHeight(this.contentHeight, newContentHeight);
                }
            });
        }
    }

    toggleActiveState(id) {
        this.stories.forEach((story) => {
            if(story.id === id) {
                story.active = true;
                story.el.classList.add('explore-block__link--active');
            } else {
                story.active = false;
                story.el.classList.remove('explore-block__link--active');
            }
        });
    }

    removeCta() {
        let ctaButton = this.el.querySelector('.explore-block__cta');
        if(ctaButton) {
            ctaButton.classList.add('explore-block__cta--inactive');
        }
    }

    addCta() {
        this.ctaEl.innerHTML = '';

        if(this.currentStory.showCta === "1") {
            let linkEl = document.createElement("a");
            linkEl.classList.add('explore-block__cta', 'explore-block__cta--inactive');
            linkEl.setAttribute('href', this.currentStory.ctaUrl);

            let labelEl = document.createElement("span");
            labelEl.classList.add('explore-block__cta-label');
            labelEl.innerText = this.currentStory.ctaLabel;

            let iconEl = document.createElement("span");
            iconEl.classList.add('explore-block__cta-arrow');
            iconEl.innerHTML = this.arrowIcon;

            linkEl.appendChild(labelEl);
            linkEl.appendChild(iconEl);

            this.ctaEl.appendChild(linkEl);
            setTimeout(() => {
                linkEl.classList.remove('explore-block__cta--inactive');
            }, 10);
        }

    }

    expandToNewContentHeight(oldHeight, newHeight) {
        anime({
            targets:this.contentEl,
            height:[oldHeight, newHeight],
            opacity:1,
            duration: 1500,
            easing: 'easeInOutExpo',
            complete: () => {
                this.contentEl.style.height = 'auto';
                this.addCta();
            }
        });
    }

    expand() {
        this.el.style.width = '100%';
        this.expandedEl.style.display = 'block';
        this.expandedEl.style.height = 'auto';
        this.expandedHeight = this.expandedEl.offsetHeight;
        this.expandedEl.style.height = 0;
        this.expandedEl.style.opacity = 0;
        this.el.style.width = '';

        anime({
            targets:this.collapsedEl,
            opacity:0,
            duration: 900,
            easing: 'easeInOutExpo',
            complete: () => {
                this.collapsedEl.style.height = 0;
                this.collapsedEl.style.display = 'none';
            }
        });

        anime({
            targets:this.el,
            width: '100%',
            duration: 1000,
            delay: 200,
            easing: 'easeInOutExpo'
        });


        anime({
            targets:this.el,
            height:[this.collapsedHeight, this.expandedHeight],
            duration: 1000,
            easing: 'easeInOutExpo',
            delay: 600,
            complete: () => {
                this.expandedEl.style.height = 'auto';
                this.el.style.height = 'auto';
            }
        });

        anime({
            targets:this.expandedEl,
            opacity:1,
            duration: 700,
            delay: 1000,
            easing: 'easeInOutExpo'
        });

    }

    collapse() {
        let elWidthAnimateFrom = getComputedStyle(this.el).width;
        this.el.style.width = '';
        let elWidthAnimateTo = getComputedStyle(this.el).width;
        this.el.style.width = '100%';
        this.expandedHeight = this.el.offsetHeight;
        this.el.style.height = this.expandedHeight + 'px';

        console.log(elWidthAnimateTo);

        anime({
            targets:this.expandedEl,
            opacity:0,
            duration: 900,
            easing: 'easeInOutExpo',
            complete: () => {
                this.expandedEl.style.height = 0;
                this.expandedEl.style.display = 'none';
            }
        });

        anime({
            targets:this.el,
            width: [elWidthAnimateFrom,elWidthAnimateTo],
            duration: 1000,
            delay: 400,
            easing: 'easeInOutExpo'
        });


        anime({
            targets:this.el,
            height:[this.expandedHeight,this.collapsedHeight],
            duration: 1000,
            easing: 'easeInOutExpo',
            delay: 400,
            begin: () => {
                this.expandedEl.style.position = 'absolute';
                this.expandedEl.style.top = 0;
                this.expandedEl.style.left = 0;
                this.expandedEl.style.right = 0;
                this.expandedEl.style.bottom = 0;
            },
            complete: () => {
                this.expandedEl.style.position = 'relative';
                this.expandedEl.style.height = 0;
                this.expandedEl.style.display = 'none';
            }
        });

        anime({
            targets:this.collapsedEl,
            opacity:[0,1],
            duration: 700,
            delay: 1000,
            easing: 'easeInOutExpo',
            begin: () => {
                this.collapsedEl.style.display = 'block';
                this.collapsedEl.style.height = 'auto';
            }
        });
    }
};